import React, { FormEvent, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { apiErrorMessage } from '../api/client';
import { Spinner } from '../components/ui';
import { config } from '../config/environment';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { token, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (token) return <Navigate to="/dashboard" replace />;

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-pattern flex min-h-screen items-center justify-center bg-app p-4">
      <div className="card w-full max-w-sm p-8">
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gold text-lg font-bold text-[#1a1408]">
            TPC
          </div>
          <div>
            <h1 className="text-xl font-semibold">TPC Admin</h1>
            <p className="text-sm text-sub">The Perfume Culture</p>
          </div>
        </div>

        {!config.isProduction && (
          <div
            className={`mb-4 rounded-lg border px-3 py-1.5 text-center text-xs font-medium ${
              config.isUAT
                ? 'border-yellow-500/30 bg-yellow-500/20 text-yellow-600 dark:text-yellow-400'
                : 'border-blue-500/30 bg-blue-500/20 text-blue-600 dark:text-blue-400'
            }`}
          >
            {config.isUAT ? '⚠️ UAT Environment' : '🔧 Development'}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="label">
              Email
            </label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              className="input"
              placeholder="admin@theperfumeculture.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="password" className="label">
              Password
            </label>
            <input
              id="password"
              type="password"
              required
              autoComplete="current-password"
              className="input"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <p className="rounded-xl border border-bad/40 bg-bad/10 px-3 py-2 text-sm text-bad" role="alert">
              {error}
            </p>
          )}

          <button type="submit" className="btn-gold w-full" disabled={busy}>
            {busy && <Spinner />}
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        {config.isDevelopment && (
          <p className="mt-4 text-center text-xs text-sub">API: {config.gatewayUrl}</p>
        )}
      </div>
    </div>
  );
}
